import { render } from "./BatchSelect.vue?vue&type=template&id=39a00fbd&scoped=true"
import script from "./BatchSelect.vue?vue&type=script&lang=js"
export * from "./BatchSelect.vue?vue&type=script&lang=js"

import "./BatchSelect.vue?vue&type=style&index=0&id=39a00fbd&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a00fbd"]])

export default __exports__